export default __webpack_public_path__ + "static/media/12-32-15 2.b6c9ade9.jpg";